import type { FC } from "react";

import type { MagentoShippingMethod } from "@jti/magento-types";
import { FormattedPrice, useTranslations } from "@jti/ui";

import styles from "./DeliveryFormShippingOptionMethodLabel.module.scss";

type DeliveryFormShippingOptionMethodLabelProps = Partial<MagentoShippingMethod>;

export const DeliveryFormShippingOptionMethodLabel: FC<DeliveryFormShippingOptionMethodLabelProps> = ({
  methodTitle,
  amount = null,
  description,
}) => {
  const { __ } = useTranslations();

  const price = amount?.value ? (
    <FormattedPrice currency={amount.currency} value={amount.value} />
  ) : (
    __("cart.shipping_options.free")
  );

  return (
    <>
      <span className={styles.name}>
        {methodTitle} - <strong>{price}</strong>
      </span>
      {description && <span className={styles.description}>{description}</span>}
    </>
  );
};
